import React from 'react';
import ReactDOM from 'react-dom';
import Game from './game';
import './styles/index.css';

ReactDOM.render(<Game />, document.body);



// WEBPACK FOOTER //
// ./src/index.js